"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationService = void 0;
/**
 * Gets the invitation id for the meeting scheduler.
 */
class InvitationService {
    /**
     * Calls listInvitationsById and returns the first invitation id found across
     * the response identifiers, or null when the request fails or no invitation
     * is present.
     */
    async getInvitationId(payload) {
        const response = await this.send(payload);
        if (!response) {
            return null;
        }
        for (const identifier of response.identifiers) {
            const firstInvitation = identifier.invitations?.[0];
            if (firstInvitation?.invitationId) {
                return firstInvitation.invitationId;
            }
        }
        return null;
    }
    /**
     * Looks up the invitation id for the APWG practice identifier from the
     * Public Site. Uses ctx 'DMU.PRAC' since this is a practice-level id.
     *
     * TODO: Confirm whether this should be looked up with ctx 'DMU.DIST'
     * (distribution) or 'DMU.PRAC' (practice). A wrong ctx won't fail validation
     * or error on id format — the service just returns no invitations.
     */
    async getApwgInvitationId() {
        return this.getInvitationId({
            srcSysNm: 'Public Site',
            identifiers: [{ id: InvitationService.APWG_PRACTICE_ID, ctx: 'DMU.PRAC' }]
        });
    }
    /**
     * Issues the raw request and returns the parsed response, or null on a
     * network error or non-OK HTTP status.
     */
    async send(payload) {
        try {
            const response = await fetch(InvitationService.ENDPOINT, {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json',
                    'OData-Version': '4.0',
                    consumer: 'id=A0056099-8CC7YJYS05J7L89Y;type=WEB'
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                return null;
            }
            return (await response.json());
        }
        catch (error) {
            console.error('InvitationService request failed', error);
            return null;
        }
    }
}
exports.InvitationService = InvitationService;
InvitationService.ENDPOINT = '/ods.svc/listInvitationsById';
InvitationService.APWG_PRACTICE_ID = '507132';
